<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
      <b-row> </b-row>
    </base-header>

    <!--Charts-->
    <b-container fluid class="mt--9">
      <b-row>
        <b-col size="12">
          <b-card>
            <b-alert v-if="error.length" show variant="danger">{{
              error
            }}</b-alert>
            <b-row>
              <b-form-group label="Fecha Inicio" class="col-2">
                <b-form-input
                  size="sm"
                  type="date"
                  v-model="filter.init"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Fecha Inicio" class="col-2">
                <b-form-input
                  size="sm"
                  type="date"
                  v-model="filter.end"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                v-if="clientes_filtered.length > 0"
                label="Cliente"
                class="col-2"
              >
                <b-form-select
                  size="sm"
                  v-model="filter.cliente"
                  @change="filterPedidos"
                >
                  <b-form-select-option
                    v-for="(cliente, ck) in clientes_filtered"
                    :key="ck"
                    :value="cliente.CODCLIENTE"
                    >{{ cliente.NOMBRECLIENTE }}</b-form-select-option
                  >
                </b-form-select>
              </b-form-group>
              <b-form-group class="d-flex align-items-end">
                <b-button
                  @click="getPedidos"
                  :disabled="working"
                  variant="primary"
                  size="sm"
                  >Buscar</b-button
                >
              </b-form-group>
            </b-row>
            <b-row>
              <b-col class="d-flex">
                <div class="mb-2">
                  <b-button
                    @click="selectAllRows"
                    size="sm"
                    variant="info"
                    class="text-primary"
                  >
                    <i class="far fa-check-double"></i> Todos
                  </b-button>
                  <b-button @click="clearSelected" size="sm" variant="warning">
                    <i class="far fa-times"></i> Deseleccionar
                  </b-button>
                </div>
                <div class="ml-auto">
                  <b-button
                    @click="syncPedidos"
                    :disabled="selected.length <= 0"
                    size="sm"
                    variant="primary"
                    >Enviar a Comercial</b-button
                  >
                </div>
              </b-col>
            </b-row>
            <b-table
              :fields="fields"
              :items="pedidos_filtered"
              :select-mode="selectMode"
              responsive="md"
              ref="selectableTable"
              selectable
              :select-row-disabled="isRowDisabled"
              @row-selected="onRowSelected"
              small
              class="notiflix-block"
            >
              <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                  <i class="fas fa-check-circle text-success"></i>
                </template>
                <template v-else>
                  <i class="far fa-circle"></i>
                </template>
              </template>
              <template #cell(ciddocumento)="data">
                <template v-if="Number.isInteger(data.item.ciddocumento)">
                  <i class="fas fa-check-circle fa-2x text-success"></i>
                </template>
                <template v-else>
                  <b-badge variant="danger">{{
                    data.item.ciddocumento
                  }}</b-badge>
                </template>
              </template>
              <template #cell(contpaq_cliente)="data">
                <!-- <span
                  @click="edit = data.item.NUMALBARAN"
                  v-if="getIdComercialWithIdICG(data.item.CODCLIENTE)"
                  >{{ getIdComercialWithIdICG(data.item.CODCLIENTE) }}</span
                > -->
                <!-- <b-badge v-else variant="danger">No asociado</b-badge> -->
                <!-- <b-form-input v-if="edit == data.item.NUMALBARAN" size="sm"
                  >Cliente</b-form-input
                > -->
                <b-form-select size="sm" v-model="data.item.contpaq_cliente">
                  <b-form-select-option
                    v-for="(cliente, ck) in clientes"
                    :key="ck"
                    :value="cliente.CCODIGOCLIENTE"
                    >{{ cliente.CRAZONSOCIAL }}</b-form-select-option
                  >
                </b-form-select>
              </template>
              <template #cell(FECHA)="data">
                {{ moment(data.item.FECHA).format("DD-MM-YYYY") }}
              </template>
              <template #cell(NUMFAC)="data">
                <div class="text-center">
                  <span class="badge badge-danger" v-if="data.item.NUMFAC <= 0"
                    >No Facturado</span
                  >
                  <span class="" v-else>{{ data.item.NUMFAC }} </span>
                </div>
              </template>
              <template #cell(actions)="row">
                {{ row }}
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      moment: moment,
      working: false,
      error: [],
      filter: {
        init: moment().format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD"),
        cliente: null,
      },
      clientes: [],
      clientes_filtered: [],
      pedidos: [],
      pedidos_filtered: [],
      fields: [
        "selected",
        {
          key: "CODCLIENTE",
          label: "Codigo",
        },
        {
          key: "NOMBRECLIENTE",
          label: "Nombre",
        },
        {
          key: "NUMALBARAN",
          label: "Albaran",
        },
        {
          key: "NUMFAC",
          label: "Num Factura",
        },
        "FECHA",
        // {
        //   key: "TOTALBRUTO",
        //   label: "Subtotal",
        //   class: "text-right",
        //   formatter: (value, key, item) => {
        //     return this.numberFormat(value)
        //   }
        // },
        // {
        //   key: "TOTALIMPUESTOS",
        //   label: "Impuestos",
        //   class: "text-right",
        //   formatter: (value, key, item) => {
        //     return this.numberFormat(value)
        //   }
        // },
        {
          key: "TOTALNETO",
          label: "Total",
          class: "text-right",
          formatter: (value, key, item) => {
            return this.numberFormat(value);
          },
        },
        {
          key: "ciddocumento",
          label: "SYNC",
          class: "text-center",
        },
        {
          key: "contpaq_cliente",
          label: "Contpaq Cliente",
        },
      ],
      selectMode: "multi",
      selected: [],
      edit: null,
    };
  },
  watch: {
    working: function (val) {
      if (val) {
        this.$notiflix.Block.standard(".notiflix-block", "Loading...");
      } else {
        this.$notiflix.Block.remove(".notiflix-block");
      }
    },
  },
  mounted() {
    this.getClientes();
    this.getPedidos();
  },
  sockets: {
    syncContpaqiResult(send) {
      let _this = this;
      let data = JSON.parse(send);

      if (data.success) {
        this.pedidos.find((albaran, ka) => {
          if (albaran.NUMALBARAN == data.id) {
            albaran.ciddocumento = data.ciddocumento;
          }
        });
      }
      if (!data.success) {
        this.pedidos.find((albaran, ka) => {
          if (albaran.NUMALBARAN == data.id) {
            albaran.ciddocumento = data.message;
          }
        });
      }
    },
  },
  methods: {
    isRowDisabled(item) {
      console.log(
        "NUMFAC:",
        item.NUMFAC,
        "Tipo:",
        typeof item.NUMFAC,
        "Es mayor que 0:",
        parseFloat(item.NUMFAC) > 0
      );

      return parseFloat(item.NUMFAC) <= 0 || isNaN(parseFloat(item.NUMFAC));
    },
    getIdComercialWithIdICG(icg_codcliente) {
      let cliente = this.clientes.find(
        (cliente) => cliente.icg_cliente_id == icg_codcliente
      );

      return cliente ? cliente.CRAZONSOCIAL : null;
    },
    getClientes() {
      this.$api.get("/pedidos/clientes").then((res) => {
        this.clientes = res.data;
      });
    },
    getPedidos() {
      this.working = true;
      this.error = [];
      this.filter.cliente = null;

      this.$api
        .get("/icg/pedidos-status", {
          params: this.filter,
        })
        .then((res) => {
          if (res.data) {
            this.pedidos = res.data;

            this.pedidos_filtered = this.pedidos;

            this.clientes_filtered = [
              ...new Map(
                this.pedidos.map((pedido) => [
                  pedido.CODCLIENTE,
                  {
                    CODCLIENTE: pedido.CODCLIENTE,
                    NOMBRECLIENTE: pedido.NOMBRECLIENTE,
                  },
                ])
              ).values(),
            ].sort((a, b) => a.NOMBRECLIENTE.localeCompare(b.NOMBRECLIENTE));
          }
        })
        .catch((e) => {
          this.error = e;
        })
        .then(() => {
          this.working = false;
        });
    },
    filterPedidos() {
      this.pedidos_filtered = this.pedidos.filter((pedido) => {
        return pedido.CODCLIENTE == this.filter.cliente;
      });
    },
    syncPedidos() {
      this.working = true;
      this.error = [];

      let _this = this;

      this.$api
        .post("/pedidos/enviar-a-comercial", {
          pedidos: this.selected,
        })
        .then((response) => {
          // _this.$notiflix.Notify.Success(response.data)
          // this.notification({
          //   message: response.data
          // })
          alert(response.data);
        })
        .catch((e) => {
          this.error = e;
        })
        .then(() => {
          this.clearSelected();
          this.working = false;
        });
    },
    onRowSelected(pedidos) {
      this.selected = pedidos.map((pedido, k, array) => {
        return {
          NUMSERIE: pedido.NUMSERIE,
          NUMALBARAN: pedido.NUMALBARAN,
          CODCLIENTE: pedido.CODCLIENTE,
          NUMFAC: pedido.NUMFAC,
          contpaq_cliente: pedido.contpaq_cliente,
        };
      });
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    selectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.selectRow(2);
    },
    unselectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.unselectRow(2);
    },
    numberFormat(val = null) {
      let options = { style: "decimal", currency: "USD" };
      let numberFormat2 = new Intl.NumberFormat("en-US", options);
      return numberFormat2.format(val);
    },
  },
};
</script>
<style>
.el-table .cell {
  padding-left: 0px;
  padding-right: 0px;
}
</style>
